import {
  Siren, CalendarDays, Stethoscope, Info, Settings,
  PawPrint,
} from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { HeartPulse } from 'lucide-react';

interface CategoryBadgeProps {
  category: string | null;
}

const categoryConfig: Record<string, { label: string; className: string; icon: React.ReactNode }> = {
  emergency: {
    label: 'EMERGENCY',
    className: 'bg-urgent/10 text-urgent border-urgent/20 dark:bg-urgent/20 dark:text-urgent dark:border-urgent/30',
    icon: <Siren className="size-3" />,
  },
  appointment_request: {
    label: 'APPOINTMENT',
    className: 'bg-info/10 text-info border-info/20 dark:bg-info/20 dark:text-info dark:border-info/30',
    icon: <CalendarDays className="size-3" />,
  },
  clinical: {
    label: 'CLINICAL',
    className: 'bg-success/10 text-success border-success/20 dark:bg-success/20 dark:text-success dark:border-success/30',
    icon: <Stethoscope className="size-3" />,
  },
  info: {
    label: 'INFO',
    className: 'bg-primary/10 text-primary border-primary/20 dark:bg-primary/20 dark:text-primary dark:border-primary/30',
    icon: <Info className="size-3" />,
  },
  admin: {
    label: 'ADMIN',
    className: 'bg-muted/50 text-muted-foreground border-border dark:bg-muted/30 dark:text-muted-foreground dark:border-border',
    icon: <Settings className="size-3" />,
  },
  spam: {
    label: 'SPAM',
    className: 'bg-red-500/10 text-red-600 border-red-500/20 dark:bg-red-500/20 dark:text-red-400 dark:border-red-500/30',
    icon: <Siren className="size-3" />,
  },
};

// Specialty icons
const specialtyIcons: Record<string, React.ReactNode> = {
  cardiology: <HeartPulse className="size-3" />,
  dermatology: <PawPrint className="size-3" />,
  orthopedics: <PawPrint className="size-3" />,
  neurology: <PawPrint className="size-3" />,
  oncology: <PawPrint className="size-3" />,
  ophthalmology: <PawPrint className="size-3" />,
};

export function CategoryBadge({ category }: CategoryBadgeProps) {
  if (!category) return null;

  const config = categoryConfig[category.toLowerCase()];

  if (!config) {
    // Check if it's a specialty
    const icon = specialtyIcons[category.toLowerCase()];
    return (
      <Badge variant="outline" className="bg-muted/50 text-muted-foreground border-border dark:bg-muted/30 dark:text-muted-foreground dark:border-border">
        {icon}
        {category.toUpperCase().replace('_', ' ')}
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className={config.className}>
      {config.icon}
      {config.label}
    </Badge>
  );
}
